// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"100px","container":"scroll-block-module--container--2WbJ6","childrenContainer":"scroll-block-module--childrenContainer--2iMcy"};